import React, { Component } from 'react';
import convertColumnTypeToDisplayName from '@/util/ColumnTypeToDisplayNameConverter';
import { getUniques } from '@/util/helpers/array-helpers';
import MultiDropdown from './MultiDropdown';
import DropdownButton from './DropdownButton';
import TableRef from '../util/TableRef';
import ViewRef from '../util/ViewRef';
import DropdownItem from '../util/DropdownItem';

const CUSTOM_COLUMN = 'CUSTOM_COLUMN';
const SQL = 'sql';

class ColumnsDropdown extends Component {
  dropdownItems() {
    const { columns } = this.props;

    const uniqueAliases = this.getUniquesAliases();

    const dropdownItems = uniqueAliases.map((alias) => {
      // get the table or insight name
      const tableName = this.getTableOrInsightName(alias);
      // for each alias, create the dropdown items (i.e. the columns)

      const columnList = columns
        .filter((c) => {
          // Call options with no alias 'custom column'
          const columnAlias = c.name().hasAlias()
            ? c.name().alias()
            : CUSTOM_COLUMN;
          const match = columnAlias === alias;
          return match;
        })
        .map((c) => {
          return DropdownItem.action(
            <span>
              {c.name().name()}{' '}
              <small className="faint">
                {convertColumnTypeToDisplayName(c.type().type())}
              </small>
            </span>,
            () => this.props.onClick(c),
          );
        });
      return DropdownItem.dropdown(tableName, columnList);
    });
    return dropdownItems;
  }

  getUniquesAliases() {
    const { columns } = this.props;
    const uniques = getUniques(columns, (n) => {
      const name = n.name().hasAlias() ? n.name().alias() : CUSTOM_COLUMN;
      return name;
    });
    return uniques;
  }

  getTableOrInsightName(alias) {
    if (alias === SQL) {
      return <span>SQL</span>;
    }
    const { aliases } = this.props;
    const tov = aliases[alias];
    // type can be table ref, view ref, or custom
    const type =
      tov && tov instanceof TableRef
        ? 'table'
        : tov && tov instanceof ViewRef
        ? 'saved query'
        : '';
    const name = tov ? tov.name() : 'custom';
    return (
      <span>
        {name}
        <small className="faint"> {type}</small>
      </span>
    );
  }

  render() {
    const { isOpen, children } = this.props;

    const style = { maxHeight: '230px', overflow: 'auto', marginTop: '10px' };

    return (
      <DropdownButton
        open={isOpen}
        contentBuilder={() => (
          <MultiDropdown items={this.dropdownItems()} style={style} />
        )}
      >
        {children}
      </DropdownButton>
    );
  }
}

export default ColumnsDropdown;
